export const DELIVERY_AREA = {
    UPDATE_ZIP_CODES_EXCEL: "UPDATE_ZIP_CODES_EXCEL",
    UPDATE_ZIP_CODES_EXCEL_SUCCESS: "UPDATE_ZIP_CODES_EXCEL_SUCCESS",
    UPDATE_ZIP_CODES_EXCEL_FAIL: "UPDATE_ZIP_CODES_EXCEL_FAIL",

    ENABLE_ZIP_CODES: "ENABLE_ZIP_CODES",
    ENABLE_ZIP_CODES_SUCCESS: "ENABLE_ZIP_CODES_SUCCESS",
    ENABLE_ZIP_CODES_FAIL: "ENABLE_ZIP_CODES_FAIL",

    MODIFY_ZIP_CODE_INFO: "MODIFY_ZIP_CODE_INFO",
    MODIFY_ZIP_CODE_INFO_SUCCESS: "MODIFY_ZIP_CODE_INFO_SUCCESS",
    MODIFY_ZIP_CODE_INFO_FAIL: "MODIFY_ZIP_CODE_INFO_FAIL",

    ADD_ZIP_CODE_INFO: "ADD_ZIP_CODE_INFO",
    ADD_ZIP_CODE_INFO_SUCCESS: "ADD_ZIP_CODE_INFO_SUCCESS",
    ADD_ZIP_CODE_INFO_FAIL: "ADD_ZIP_CODE_INFO_FAIL",

    ADD_NEW_ZONE: "ADD_NEW_ZONE",
    ADD_NEW_ZONE_SUCCESS: "ADD_NEW_ZONE_SUCCESS",
    ADD_NEW_ZONE_FAIL: "ADD_NEW_ZONE_FAIL",

    GET_PARTNERS_WAREHOUSE: "GET_PARTNERS_WAREHOUSE",
    GET_PARTNERS_WAREHOUSE_SUCCESS: "GET_PARTNERS_WAREHOUSE_SUCCESS",
    GET_PARTNERS_WAREHOUSE_FAIL: "GET_PARTNERS_WAREHOUSE_FAIL",

    MODIFY_PARTNERS_WAREHOUSE: "MODIFY_PARTNERS_WAREHOUSE",
    MODIFY_PARTNERS_WAREHOUSE_SUCCESS: "MODIFY_PARTNERS_WAREHOUSE_SUCCESS",
    MODIFY_PARTNERS_WAREHOUSE_FAIL: "MODIFY_PARTNERS_WAREHOUSE_FAIL",

    GET_ALL_AIRPORT: "GET_ALL_AIRPORT",
    GET_ALL_AIRPORT_SUCCESS: "GET_ALL_AIRPORT_SUCCESS",
    GET_ALL_AIRPORT_FAIL: "GET_ALL_AIRPORT_FAIL",

    MODIFY_ZONE_STATE: "MODIFY_ZONE_STATE",
    MODIFY_ZONE_STATE_SUCCESS: "MODIFY_ZONE_STATE_SUCCESS",
    MODIFY_ZONE_STATE_FAIL: "MODIFY_ZONE_STATE_FAIL",

    GET_ALL_ZONE: "GET_ALL_ZONE",
    GET_ALL_ZONE_SUCCESS: "GET_ALL_ZONE_SUCCESS",
    GET_ALL_ZONE_FAIL: "GET_ALL_ZONE_FAIL",

    GET_ALL_ZIP_CODES: "GET_ALL_ZIP_CODES",
    GET_ALL_ZIP_CODES_SUCCESS: "GET_ALL_ZIP_CODES_SUCCESS",
    GET_ALL_ZIP_CODES_FAIL: "GET_ALL_ZIP_CODES_FAIL",

    GET_PARTNERS: "GET_PARTNERS",
    GET_PARTNERS_SUCCESS: "GET_PARTNERS_SUCCESS",
    GET_PARTNERS_FAIL: "GET_PARTNERS_FAIL",

    HANDLE_ROW_VALUES: "HANDLE_ROW_VALUES",

    MODIFY_ZONE_DETAIL_INFO: "MODIFY_ZONE_DETAIL_INFO",
    MODIFY_ZONE_DETAIL_INFO_SUCCESS: "MODIFY_ZONE_DETAIL_INFO_SUCCESS",
    MODIFY_ZONE_DETAIL_INFO_FAIL: "MODIFY_ZONE_DETAIL_INFO_FAIL"
}